import { TableCell, Typography, Stack } from "@mui/material";
import { TopBottomType } from "../../../../../domain/models/executive-summary/top-bottom-type";
import { DownloadJSONExecutive } from "../../../../../domain/models/executive-summary/download-json-executive";

type Props = {
  data: TopBottomType;
  downloadJSON: DownloadJSONExecutive[];
};

const TopBottomData: React.FC<Props> = ({ data, downloadJSON }) => {
  const jsonData: DownloadJSONExecutive = {
    role: "TSO",
    area_name: data.area_name,
    hq_name: data.hq_name,
    total_target: `₹${data.target}`,
    target_orders: data.targer_orders,
    total_sales: `₹${data.sales}`,
    sales_order: data.sales_orders,
    percentage: `${data.percentage}%`,
    growth: `${data.growth}%`,
    cpay_invoices: `₹${data.channelPay.invoices}`,
    cpay_invoices_count: data.channelPay.invoices_count,
    cpay_orders: `₹${data.channelPay.order}`,
    cpay_orders_count: data.channelPay.order_count,
    cpay_active: `${data.channelPay.active}/${data.channelPay.total}`,
    cpaisa_invoices: `₹${data.channelPaisa.invoices}`,
    cpaisa_invoices_count: data.channelPaisa.invoices_count,
    cpaisa_orders: `₹${data.channelPaisa.order}`,
    cpaisa_orders_count: data.channelPaisa.order_count,
    cpaisa_active: `${data.channelPaisa.active}/${data.channelPaisa.total}`,
  };

  downloadJSON.push(jsonData);

  return (
    <>
      <TableCell padding="none" align="center">
        {data.region_name}
      </TableCell>
      <TableCell padding="none" align="center">
        {data.area_name}
      </TableCell>
      <TableCell padding="none" align="center">
        {data.hq_name}
      </TableCell>
      <TableCell padding="none" align="center">
        <Typography fontSize={13}>₹{data.target}</Typography>
        <Typography fontSize={11} color={"gray"}>
          {data.targer_orders} ORDERS
        </Typography>
      </TableCell>
      <TableCell padding="none" align="center">
        <Typography fontSize={13}>₹{data.sales}</Typography>
        <Typography fontSize={11} color={"gray"}>
          {data.sales_orders} ORDERS
        </Typography>
      </TableCell>
      <TableCell padding="none" align="center">
        {data.percentage}%
      </TableCell>
      <TableCell padding="none" align="center">
        {data.growth}%
      </TableCell>
      <TableCell padding="none" />
      <TableCell padding="none" align="center">
        <Typography fontSize={13}>₹{data.channelPay.invoices}</Typography>
        <Typography fontSize={11} color={"gray"}>
          {data.channelPay.invoices_count} INVOICES
        </Typography>
      </TableCell>
      <TableCell padding="none" align="center">
        <Typography fontSize={13}>₹{data.channelPay.order}</Typography>
        <Typography fontSize={11} color={"gray"}>
          {data.channelPay.order_count} ORDERS
        </Typography>
      </TableCell>
      <TableCell padding="none" sx={{ textAlign: "center" }}>
        <Stack direction={"row"} justifyContent={"center"}>
          <Typography color={"green"} fontSize={15} fontWeight={500}>
            {data.channelPay.active}
          </Typography>
          <Typography fontSize={15}>/{data.channelPay.total}</Typography>
        </Stack>
      </TableCell>
      <TableCell padding="none" />
      <TableCell padding="none" align="center">
        <Typography fontSize={13}>₹{data.channelPaisa.invoices}</Typography>
        <Typography fontSize={11} color={"gray"}>
          {data.channelPaisa.invoices_count} INVOICES
        </Typography>
      </TableCell>
      <TableCell padding="none" align="center">
        <Typography fontSize={13}>₹{data.channelPaisa.order}</Typography>
        <Typography fontSize={11} color={"gray"}>
          {data.channelPaisa.order_count} ORDERS
        </Typography>
      </TableCell>
      <TableCell padding="none" sx={{ textAlign: "center" }}>
        <Stack direction={"row"} justifyContent={"center"}>
          <Typography color={"green"} fontSize={15} fontWeight={500}>
            {data.channelPaisa.active}
          </Typography>
          <Typography fontSize={15}>/{data.channelPaisa.total}</Typography>
        </Stack>
      </TableCell>
      <TableCell padding="none" />
    </>
  );
};

export default TopBottomData;
